export default __webpack_public_path__ + "static/media/Download.d61197ce.svg";